import { SharedService } from './../../services/shared/shared.service';
import { UserService } from './../../services/user/user.service';
import { Storage } from '@ionic/storage';
import { Events, ToastController, ModalController, AlertController, LoadingController } from '@ionic/angular';
import { Component, OnInit, Input } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { environment } from 'src/environments/environment';
import { PricelistModalPage } from 'src/app/pricelist-modal/pricelist-modal.page';
import { ConfigService } from 'src/app/services/config/config.service';
import { ProductSubscriptionsService } from 'src/app/services/product-subscriptions/product-subscriptions.service';
import { CartService } from 'src/app/services/cart/cart.service';
import { Subscription } from 'rxjs';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { LabelService } from 'src/app/services/label/label.service';
import { encodeURL } from 'src/app/services/parseURL';
import { DesignStudioService } from 'src/app/services/design-studio/design-studio.service';
@Component({
    selector: 'app-product-grid',
    templateUrl: './product-grid.component.html',
    styleUrls: ['./product-grid.component.scss'],
})

export class ProductGridComponent implements OnInit {
    @Input() products: any = [];
    @Input() cartProducts: any = [];
    @Input() gridType: any;
    @Input() isSidebar: any; 
    @Input() style: any; 
    isPriceReq: boolean;
    showPrices: boolean;
    role: string;
    minOrderAmount = 0;
    currencyCode: any;
    userId = '';
    loading: any;
    subCatId;
    subCatName;
    categoryId;
    urlCategoryName: string = '';
    urlSubCatName: string = '';;
    subscriptionFeature = false;
    RFQFeature = false;
    urlCategoryId: string;
    urlSubCatId: string;
    categoryName: string;
    SHARED_LABELS: any = {};
    colClass;
    designStudioActive;

    constructor(private router: Router,
        private events: Events,
        private storage: Storage,
        private userService: UserService,
        private toastController: ToastController,
        private modalController: ModalController,
        private alertController: AlertController,
        private loadingController: LoadingController,
        private sharedService: SharedService,
        private productSubscriptionsService: ProductSubscriptionsService,
        private configService: ConfigService,
        private cartService: CartService,
        private utilsService: UtilsService,
        private labelService: LabelService,
        private designStudioService:DesignStudioService,
        private activatedRoute: ActivatedRoute) {

    }

    goToProduct(index: number) {
        const productName = this.products[index].data.prodName;
        const productID = this.products[index].id;
        this.router.navigate([this.getProductRouteUrl(productName, productID)]);
    }

    ngOnChanges() {
        this.preparePageData();
    }

    async preparePageData() {
        this.designStudioActive = this.designStudioService.designStudioActive;
        if (!this.style || Object.keys(this.style).length === 0 || !this.designStudioActive) {
            this.style = await this.designStudioService.getSessionStorageGlobalData(); 
        }

        this.colClass = `lg-col-${this.style.productStyle.gridColumn.lg} md-col-${this.style.productStyle.gridColumn.md} sm-col-${this.style.productStyle.gridColumn.sm}`;
        

        for (const product of this.products) {
            if(!product.data) {
                product.data = product;
            }
        }

        this.priceRequestFeature();
        this.SHARED_LABELS = this.labelService.labels['SHARED'];

        this.categoryId = this.activatedRoute.snapshot.paramMap.get('c_id');
        this.categoryName = this.activatedRoute.snapshot.paramMap.get('c_name');
        this.subCatName = this.activatedRoute.snapshot.paramMap.get('s_c_name');
        this.subCatId = this.activatedRoute.snapshot.paramMap.get('s_c_id');
        this.currencyCode = this.configService.environment.currencyCode;
        this.RFQFeature = this.configService.environment.RFQFeature;
        this.userId = this.userService.getUserId();
        this.initializeSubscriptions();
        this.subscriptionFeature = this.configService.environment.subscriptionFeature;
        if (this.subscriptionFeature) {
            let subscriptionData: any = await this.productSubscriptionsService.getSettings('return');
            if (!this.isEmptyObj(subscriptionData)) {
                this.subscriptionFeature = typeof subscriptionData.isActive !== 'undefined' ? subscriptionData.isActive : false;
            }
        }
    }

    async ngOnInit() {
        this.preparePageData();
    }

    ngOnDestroy() {
        this.removeSubscriptions();
    }

    async initializeSubscriptions() {

    }

    isProductSubAvailable(product) {
        return this.subscriptionFeature && product.hasOwnProperty('subscription') && product.subscription.isAllowed ? true : false;
    }

    removeSubscriptions() {
    }

    priceRequestFeature() {
        this.isPriceReq = this.configService.environment.priceReqFeature;
        if (this.isPriceReq) {
            this.storage.get('showPrices').then((val) => {
                this.showPrices = val;
                this.storage.get('userRole').then((role) => {
                    this.role = role;
                });
            });
        }
    }

    onClickProduct(id: string, product: any) {
        const navigationExtras: NavigationExtras = {
            state: {
                productId: id,
            }
        };
        this.router.navigate(['product-details'], navigationExtras);
    }

    checkPdtStock(pdt) {
        let isOutOfStock = false;
        if (!pdt.isPriceList) {
            if (pdt.productQty === '0' && pdt.stopWhenNoQty) {
                isOutOfStock = true;
            }
        } else {
            if (pdt.stopWhenNoQty) {
                for (const pl of pdt.priceList) {
                    if (pl.totalQuantity !== '0') {
                        isOutOfStock = false;
                        break;
                    } else {
                        isOutOfStock = true;
                    }
                }
            }
        }
        return isOutOfStock;
    }

    getDiscountPercent(discountedPrice, prodPrice) {
        if (prodPrice > discountedPrice) {
            const discount = Math.round(((prodPrice - discountedPrice) / prodPrice) * 100);
            return discount;
        } else {
            return 0;
        }
    }

    removeHtml(desc) {
        const tagsRemoved = desc.replace(/(<([^>]+)>)/ig, '');
        const plainTxt = document.createElement('textarea');
        plainTxt.innerHTML = tagsRemoved;
        return plainTxt.value;
    }

    maxQtyReached() {
        this.presentToast(`${this.SHARED_LABELS['max_quantity_reach_msg']}`, 'warning');
    }

    async presentToast(msg: string, clr) {
        const toast = await this.toastController.create({
            message: msg,
            duration: 2000,
            position: 'top',
            color: clr

        });
        toast.present();
    }

    isProductInCart(product) {
        return this.cartService.isProductInCart(product)
    }

    async openPriceModal(index: number) {
        const product = this.products[index];
        const listOfWeights = [];
        for (let i = 0; i < product.data.priceList.length; i++) {
            listOfWeights.push(product.data.priceList[i].weight);
        }
        product.data.priceList.map((entry) => {
            entry.quantity = 0;
        });
        const productURL = this.getProductRouteUrl(product.data.prodName, product.id);
        const modal = await this.modalController.create({
            component: PricelistModalPage,
            cssClass: 'price-list-modal',
            componentProps: {
                product: product,
                listOfWeights: listOfWeights,
                cartProducts: this.cartProducts,
                productURL
            }
        }) ;
        await modal.present();
    }

   

    getProductRouteUrl(productName: string, productID: string) {
        if(this.categoryName) {
            if(this.subCatName) {
                return `product-details/${this.categoryName}/${this.categoryId}/${this.subCatName}/${this.subCatId}/${this.urlPdtName(productName)}/${productID}`;
            } else {
                return `product-details/${this.categoryName}/${this.categoryId}/${this.urlPdtName(productName)}/${productID}`;
            }
        } else {
            return `product-details/${this.urlPdtName(productName)}/${productID}`;
        }
    }

    async addProductToCart(index: number) {
        const product = this.products[index];
        const isCartAvailable = await this.cartService.checkCartAvailability(product.data.inactiveByVendor);
        if (isCartAvailable) {
            const cartObj = this.cartService.getCartObj(product.data, product.id);
            const cartId = await this.cartService.addProductToCart(cartObj);
            this.products[index].cartQty = 1;
            this.products[index].cartId = cartId;
        }
    }

    async decrementQuantity(index: number) {
        if (this.products[index].cartQty > 1) {
          const res = await this.cartService.updateCartState(
            this.products[index].cartId,
            this.products[index].cartQty -1
          );
          if (!res) {
            return;
          }
          this.products[index].cartQty -= 1;
          this.products[index]["cartUpdateTimer"] =
            this.products[index]["cartUpdateTimer"] || null;
          clearTimeout(this.products[index]["cartUpdateTimer"]);
          this.products[index]["cartUpdateTimer"] = setTimeout(() => {
            this.cartService.updateCartProduct(
              this.products[index].cartId,
              this.products[index].cartQty
            );
          }, 800);
        } else {
          this.cartService.deleteCartProduct(this.products[index].cartId);
        }
      }
      
      async incrementQuantity(index: number) {
        const res = await this.cartService.updateCartState(
          this.products[index].cartId,
          this.products[index].cartQty +1
        );
        if (!res) {
          return;
        }
        this.products[index].cartQty += 1;
        this.products[index]["cartUpdateTimer"] =
          this.products[index]["cartUpdateTimer"] || null;
        clearTimeout(this.products[index]["cartUpdateTimer"]);
        this.products[index]["cartUpdateTimer"] = setTimeout(() => {
          this.cartService.updateCartProduct(
            this.products[index].cartId,
            this.products[index].cartQty
          );
        }, 800);
    }

    async presentAlert(msg: string) {
        const alert = await this.alertController.create({
            message: msg,
            buttons: [`${this.SHARED_LABELS['ok']}`]
        });

        await alert.present();
    }

    async presentLoading() {
        this.loading = await this.loadingController.create({
            message: this.SHARED_LABELS['please_wait'],
            duration: 5000
        });
        await this.loading.present();
    }

    isEmptyObj(object) {
        for (const key in object) {
            if (object.hasOwnProperty(key)) {
                return false;
            }
        }
        return true;
    }

    getMinPrice(pl: any) {
        const dPList = [];
        pl.forEach(e => {
            dPList.push(e.discountedPrice);
        });
        return Math.min(...dPList);
    }
    getMaxPrice(pl: any) {
        const dPList = [];
        pl.forEach(e => {
            dPList.push(e.discountedPrice);
        });
        return Math.max(...dPList);
    }

    

    async heartClicked(i: number) {
        const pid = this.products[i].id;
        const res = await this.sharedService.checkLoginStatus(`${this.SHARED_LABELS['must_be_user_to_use_wishlisht_msg']}`);
        if (res) {
            const isWishlisted = this.products[i].isWishlisted;
            if (!isWishlisted) {
                this.events.publish('wishlist:heartClicked', pid, 'not_in_list', i);
                this.products[i].isWishlisted = true;
                this.presentToast(`${this.SHARED_LABELS['item_added_to_wishlist_msg']}`, 'success');
            } else {
                this.events.publish('wishlist:heartClicked', pid, 'in_list', i);
                this.products[i].isWishlisted = false;
                this.presentToast(`${this.SHARED_LABELS['item_removed_from_wishlist_msg']}`, 'danger');
            }
        }
    }

    async priceListFirstToCart(index: number) {
        const product = this.products[index];
        const isCartAvailable = await this.cartService.checkCartAvailability();
        if (isCartAvailable) {
            const cartObj = this.cartService.getPriceListCartObj(product);
            const cartId = await this.cartService.addProductToCart(cartObj);
            this.products[index].cartQty = 1;
            this.products[index].cartId = cartId;
        }
    }

    async deleteWishlistPdt(i: number) {
        const pid = this.products[i].id;
        await this.presentLoading();
        this.events.publish('wishlist:deleteProduct', pid, i);
        this.products.splice(i, 1);
        if (this.loading) {
            this.loading.dismiss();
        }
        this.presentToast(`${this.SHARED_LABELS['item_removed_from_wishlist_msg']}`, 'danger');
    }

    urlPdtName(pname: string) {
        return encodeURL(pname);
    }

    getPriceListDiscountPercent(priceList) {
        if(priceList && priceList.length) {
            const plDiscountList = [];
            priceList.forEach(pl => {
                const plDiscount = ((pl.price - pl.discountedPrice) / pl.price) * 100;
                plDiscountList.push(plDiscount);
            });
            return parseFloat((Math.max(...plDiscountList)).toFixed(2));
        } else {
            return 0;
        }
    }


}
